import React, { Component } from 'react';
import Datasort from 'react-data-sort';
import { HOST, ENDPOINTS } from '../../constants/api';
import moment from 'moment';

class DoximStatementList extends Component {
  /**
   * Render the component view.
   */
  render() {
    let url = this.props.url;

    return (
      <div className="statement-body">
        {this.props.tableData.length == 0 && <center>No Records found</center>}
        {this.props.tableData.length != 0 && <Datasort
          data={this.props.tableData}
          paginate
          render={({ 
            data,
            setSortBy,
            sortBy,
            direction,
            activePage,
            toggleDirection,
            goToPage,
            nextPage,
            prevPage,
            pages
           }) => {
            return <div className="table-responsive-lg">
              <table className="table table-bordered table-hover">
                <thead className="thead-light">
                  <tr>
                    <th className="text-left">{this.props.whiteLabel.labels['Account Holder']}</th>
                    <th className="text-left">{this.props.whiteLabel.labels['Document Type']}</th>
                    <th className="text-left">{this.props.whiteLabel.labels['Date']}</th>
                    <th className="text-left">{this.props.whiteLabel.labels['View Statements']}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map(({
                    accountHolderName,
                    subAppCode,
                    date,
                    url,
                    guid
                    }) => (
                      <tr key={guid}>
                        <td>{accountHolderName}</td>
                        <td>{this.props.whiteLabel.labels[subAppCode]}</td>
                        <td>{moment(date).format('MM/DD/YYYY')}</td>
                        <td><a href={`${HOST}/loan/get-statement-pdf?pdfUrl=${btoa(url)}&accessToken=${localStorage.accessToken}`} target="_blank" className="link-no-style">{this.props.whiteLabel.labels['View']} </a></td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <Flex style={{justifyContent: 'space-between'}}>
              <GoToPage goToPage={goToPage} pages={pages} labels={this.props.whiteLabel.labels} />
              <PageIndicator pages={pages} activePage={activePage} />
              <Navigation
                activePage={activePage}
                goToPage={goToPage}
                nextPage={nextPage}
                prevPage={prevPage}
                pages={pages}
              />
              
            </Flex>
            </div>
          }}
        />}
      </div>
    );
  }
}

function Flex({ children, style }) {
  return <div style={{ display: "flex", ...style }}>{children}</div>;
}

function GoToPage({ goToPage, pages, labels}) {
  const options = []
  for(let i = 0; i < pages; i++) {
    options.push(<option value={i}>{i + 1}</option>)
  }
  return <div>{labels["Go to page"]} <select onChange={e => goToPage(parseInt(e.target.value))}>{options}</select></div>
}

function Navigation({ activePage, goToPage, nextPage, prevPage, pages }) {
  return (
    <Flex>
      <button disabled={activePage === 0} onClick={() => goToPage(0)}>
        {"<<"}
      </button>
      <button disabled={activePage === 0} onClick={prevPage}>
        {"<"}
      </button>

      <button disabled={activePage === pages - 1} onClick={nextPage}>
        {">"}
      </button>
      <button
        disabled={activePage === pages - 1}
        onClick={() => goToPage(pages - 1)}
      >
        {">>"}
      </button>
    </Flex>
  );
}

function PageIndicator ({pages, activePage}) {
  return <div>
    <b>{activePage + 1}</b> / {pages}
  </div>
} 

export default DoximStatementList;